import { SortableItemComponent } from './sortable-item';
import { SortableItemsListComponent } from './sortable-items-list';

export const COMPONENTS = [
  SortableItemComponent,
  SortableItemsListComponent
];